import { styled } from 'styled-components'
import { Breakpoint } from 'react-socks'
import { Tabs } from 'antd'
import { useContext, useMemo } from 'react'
import { Routes, useNavigate } from 'react-router-dom'
import { dimens } from '../shared-constants/dimens'
import ContentLayout from './ContentLayout'
import { NavLink } from 'react-router-dom'
import { colors } from '../shared-constants/colors'
import HeaderSmallUp from './header/HeaderSmallUp'
import { CText } from './CText'
import { fontSize } from '../shared-constants/fonts'
import Footer from './Footer'
import { DEVICE } from '../shared-constants/breakPoints'
import TitleCart from '@/components/basket/TitleCart'
import { HomeContext } from '../shared-contexts/HomeContext'

const Layout = ({
  children,
  header,
  menu: Menu,
  routes,
  title,
  extraComponent,
}: any) => {
  const { tiles } = useContext(HomeContext)
  const navigate = useNavigate()

  const items = useMemo(() => {
    // Expensive mapping operation
    return routes?.map((item, index) => ({
      label: (
        <span>
          <NavLink
            to={item.path}
            className={(navData) =>
              navData.isActive ? 'menu-active-link' : ''
            }
          >
            {({ isActive, isPending }: any) => (
              <>
                {isActive ? (
                  <img src={item.activeIcon} />
                ) : (
                  <img src={item.icon} />
                )}
                <TabTitle active={isActive}>{item.title}</TabTitle>
              </>
            )}
          </NavLink>
        </span>
      ),
      key: index,
    }))
  }, [routes])

  const onTabClick = (key) => {
    navigate(routes[key].path)
  }
  return (
    <LayoutContainer>
      <Breakpoint large up>
        <HeaderSmallUp extraComponent={extraComponent} tiles={tiles} />
        <SmallUpContainer>
          <ContentLayout>
            {title ? <PageTitle>{title}</PageTitle> : null}
            {routes ? <Tabs onTabClick={onTabClick} items={items} /> : null}
          </ContentLayout>
        </SmallUpContainer>
        {/* <Tabs items={items} /> */}
        <main>{children}</main>
        <Footer />
      </Breakpoint>

      <Breakpoint medium down>
        <main>{children}</main>
        {Menu ? <Menu /> : null}
      </Breakpoint>
    </LayoutContainer>
  )
}

export default Layout

const LayoutContainer = styled.div`
  /* padding:${dimens.SPACING_M}; */
  main {
    margin: auto;
    max-width: 900px;
    overflow-y: auto;
  }
  @media ${DEVICE.tablet} {
    main {
      padding-bottom: 109px;
    }
  }

  @media ${DEVICE.laptop} {
    main {
      padding-bottom: 240px;
    }
  }
`

const TabTitle = styled.span`
  margin: ${dimens.SPACING_S};
  color: ${(props) => (props.active ? colors.PRIMARY : colors.text1)};
`

const PageTitle = styled.h1`
  font-size: ${fontSize.LARGE};
  margin-bottom: ${dimens.SPACING_XL};
`
const SmallUpContainer = styled.div`
  margin: 6.5rem auto 0 auto;
  max-width: 992px;
`
